import { Box, Button, Divider, Heading, Icon, Text } from '@medely/ui-kit';
import { ContentLoader, JobDetailsListItem } from '@mp/components';
import React from 'react';
import { usePhoneScreeningScheduledData } from './usePhoneScreeningScheduledData';
import { useApplicationMutations } from '../../applicationFlowMutations';

export const PhoneScreeningScheduled = () => {
  const { isLoading, date, time, recruiterMessage, cancelScreening, isMutationPending } =
    usePhoneScreeningScheduledData();

  const { prevStep } = useApplicationMutations();

  const handleRescheduleClick = () => {
    cancelScreening();
    prevStep();
  };

  return (
    <ContentLoader loading={isLoading}>
      <>
        <Box mb={2}>
          <Heading size="m" color="text.primary">
            Your interview is confirmed
          </Heading>
        </Box>
        <Divider />
        <Box py={2}>
          <JobDetailsListItem
            icon={
              <Icon name="light-calendar" iconSize="20px" color="text.primary" variant="custom" />
            }
            title="Date"
          >
            <Text size="m">{date}</Text>
          </JobDetailsListItem>
        </Box>
        <Box py={2}>
          <JobDetailsListItem
            icon={<Icon name="light-clock" iconSize="20px" color="text.primary" variant="custom" />}
            title="Time"
          >
            <Text size="m">{time}</Text>
          </JobDetailsListItem>
        </Box>
        <Box py={2}>
          <JobDetailsListItem
            icon={<Icon name="user-search" iconSize="20px" color="text.primary" variant="custom" />}
            title="Your clinical specialist"
          >
            <Text size="m">{recruiterMessage}</Text>
          </JobDetailsListItem>
        </Box>
        <Divider />
        <Box py={2} alignSelf="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={handleRescheduleClick}
            loading={isMutationPending}
            disabled={isMutationPending}
          >
            Reschedule
          </Button>
        </Box>
      </>
    </ContentLoader>
  );
};
